import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAffiliate } from './useAffiliate';
import { useDispatch } from 'react-redux';
import { clearCart, clearPromoCodes, removePromoCodes } from '../store/cartSlice';

export const useApplyRefPromo = (handleApplyPromoCode, subtotal, submittedPromoCodes) => {
  const dispatch = useDispatch();
  const { affiliate } = useAffiliate();
  const location = useLocation();

  const getAffiliateCode = () => {
    const params = new URLSearchParams(location.search);
    const queryCode = params.get("ref");
    if (queryCode) return queryCode;

    const match = location.pathname.match(/^\/partners\/([^/?#]+)/);
    if (match) return match[1];

    return null;
  };

  const getPromoCode = () => {
    const params = new URLSearchParams(location.search);
    return params.get("promo");
  };

  const ref = getAffiliateCode();
  const promoCode = getPromoCode();

  const affiliateCodes = submittedPromoCodes
    ?.filter(promo => promo.is_affiliate)
    .map(promo => promo.code);

    
  useEffect(() => {
    const applyPromo = async () => {
      // Apply url promo discount
      if (promoCode && !submittedPromoCodes?.some(p => p.code.toUpperCase() === promoCode.toUpperCase())) {
        dispatch(clearPromoCodes());
        await handleApplyPromoCode(promoCode);
      }
      
      // Apply affiliate auto discount
      if (affiliate?.auto_discount && affiliate?.auto_promocode ) {
        await handleApplyPromoCode(affiliate.auto_promocode);
      } else if ((!affiliate?.auto_discount || ref !== affiliate?.code) && affiliateCodes?.length) {
        dispatch(removePromoCodes(affiliateCodes));
      }
    };

    applyPromo();
  }, [affiliate, ref, subtotal, promoCode]);
};
